export const deprecated = (message) => {
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line
        console.warn(`DEPRECATED: ${message}`);
    }
};
